import {InputAdornment, TextField} from '@mui/material';
import {mergeSlotProps} from '@mui/material/utils';
import PropTypes from 'prop-types';

const NumberField = ({
  unit,
  min,
  max,
  step,
  inputProps,
  InputProps,
  fullWidth,
  ...props
}) => {
  return (
    <TextField
      fullWidth={fullWidth}
      size="small"
      type="number"
      variant="outlined"
      margin="dense"
      slotProps={{
        htmlInput: mergeSlotProps(
          {
            min,
            max,
            step,
            sx: {
              paddingBlock: 1,
            },
          },
          inputProps ?? {},
        ),
        input: mergeSlotProps(
          {
            endAdornment: unit ? (
              <InputAdornment position="end">{unit}</InputAdornment>
            ) : undefined,
          },
          InputProps ?? {},
        ),
      }}
      {...props}
    />
  );
};

NumberField.propTypes = {
  unit: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  fullWidth: PropTypes.bool,
};

export default NumberField;
